(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c-slider"] && !Shopify.designMode) return;
  try {
    
class Slider {
  constructor(root) {
    this.root = root;
    this.track = root.querySelector('.c-slider__track');
    this.slides = [...root.querySelectorAll('.c-slider__slide')];

    this.prevBtn = root.querySelector('.js-prev');
    this.nextBtn = root.querySelector('.js-next');
    this.dots = [...root.querySelectorAll('.js-dot')];

    this.current = 0;
    this.position = 0;

    this.slideWidth = this.root.offsetWidth;

    this.autoplay = root.dataset.autoplay === 'true';
    this.speed = Number(root.dataset.speed);

    this.animating = false;

    this.timer = null;

    this.startX = 0;
    this.currentX = 0;
    this.isDragging = false;

    this.init();
  }

  init() {
    this.setupLoop();
    this.bindEvents();
    this.updateDots();

    if (this.autoplay) {
      this.startAutoplay();
    }

    console.log('Slider initialized', this.root);
  }

  setupLoop() {
    const slidesHTML = this.track.innerHTML;

    this.track.innerHTML =
      slidesHTML + slidesHTML + slidesHTML;

    this.allSlides = [...this.track.children];

    this.slideCount = this.slides.length;

    this.current = this.slideCount;

    this.jumpTo(this.current);
  }

  translate(px) {
    this.track.style.transform = `translateX(${px}px)`;
  }

  setPosition(position) {
    this.position = position;
    this.translate(this.position);
  }

  getPositionFromIndex(index) {
    return -(index * this.slideWidth);
  }

  jumpTo(index) {
    this.track.style.transition = 'none';

    this.current = index;

    this.position =
      this.getPositionFromIndex(index);

    this.translate(this.position);
  }

  slideTo(index) {
    if (this.animating) return;

    this.animating = true;

    this.track.style.transition =
      'transform 0.8s ease';

    this.current = index;

    this.position =
      this.getPositionFromIndex(index);

    this.translate(this.position);

    this.updateDots();

    setTimeout(() => {
      this.normalize();
      this.updateDots();

      this.animating = false;
    }, 800);
  }

  next() {
    if (this.animating) return;

    this.slideTo(this.current + 1);
  }

  prev() {
    if (this.animating) return;

    this.slideTo(this.current - 1);
  }

  normalize() {
    if (this.current >= this.slideCount * 2) {
      this.jumpTo(
        this.current - this.slideCount
      );
    }

    if (this.current < this.slideCount) {
      this.jumpTo(
        this.current + this.slideCount
      );
    }
  }

  updateDots() {
    const realIndex =
      ((this.current % this.slideCount) +
        this.slideCount) %
      this.slideCount;

    this.dots.forEach((dot, i) => {
      dot.classList.toggle(
        'is-active',
        i === realIndex
      );

      dot.setAttribute(
        'aria-selected',
        i === realIndex
      );
    });
  }

  startAutoplay() {
    if (!this.autoplay) return;

    this.stopAutoplay();

    this.timer = window.setInterval(() => {

      if (document.hidden) return;

      if (this.animating) return;

      this.next();

    }, this.speed);
  }

  stopAutoplay() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  bindEvents() {

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => {
        this.next();
        this.stopAutoplay();
      });
    }

    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => {
        this.prev();
        this.stopAutoplay();
      });
    }

    this.dots.forEach(dot => {
      dot.addEventListener('click', () => {

        const i = Number(dot.dataset.index);

        this.slideTo(
          this.slideCount + i
        );

        this.stopAutoplay();

      });
    });

    const isMobile = () =>
      window.innerWidth <= 749;

    this.track.addEventListener(
      'pointerdown',
      (e) => {

        if (!isMobile()) return;

        this.isDragging = true;

        this.startX = e.clientX;
        this.currentX = e.clientX;

        this.track.style.transition =
          'none';

      }
    );

    window.addEventListener(
      'pointermove',
      (e) => {

        if (!this.isDragging) return;

        this.currentX = e.clientX;

        const diff =
          this.currentX - this.startX;

        this.translate(
          this.position + diff
        );
      }
    );

    window.addEventListener(
      'pointerup',
      () => {

        if (!this.isDragging) return;

        this.isDragging = false;

        const diff =
          this.currentX - this.startX;

        if (diff > 50) {

          this.prev();

        } else if (diff < -50) {

          this.next();

        } else {

          this.slideTo(this.current);

        }
      }
    );

    window.addEventListener(
      'resize',
      () => {

        this.slideWidth =
          this.root.offsetWidth;

        this.jumpTo(this.current);

      }
    );

    this.root.addEventListener(
      'mouseenter',
      () => {
        this.stopAutoplay();
      }
    );

    this.root.addEventListener(
      'mouseleave',
      () => {

        if (this.autoplay) {
          this.startAutoplay();
        }

      }
    );
  }
}

document
  .querySelectorAll('.js-slider')
  .forEach((el) => {
    new Slider(el);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-curry"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-wine"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

document.addEventListener("DOMContentLoaded", function () {
  const selectHousou = document.querySelector('select[name="options[包装]"]');
  const js_noshi3 = document.querySelector(".js_noshi3");

  function toggleVisibility() {
    if (selectHousou && selectHousou.value === "なし") {
      js_noshi3.style.display = "none";
    } else {
      js_noshi3.style.display = "";
    }
  }

  // 初期状態の確認
  toggleVisibility();

  // セレクトボックスの変更を監視
  selectHousou.addEventListener("change", toggleVisibility);
});
       

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-winvertwo"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  
document.addEventListener("DOMContentLoaded", function () {
  const selectHousou = document.querySelector('select[name="options[包装]"]');
  const js_noshi3 = document.querySelector(".js_noshi3");

  function toggleVisibility() {
    if (selectHousou && selectHousou.value === "なし") {
      js_noshi3.style.display = "none";
    } else {
      js_noshi3.style.display = "";
    }
  }

  // 初期状態の確認
  toggleVisibility();

  // セレクトボックスの変更を監視
  selectHousou.addEventListener("change", toggleVisibility);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
